import { storageKeys } from '@/config/app';
import { local } from '@/lib/storage';

export type Theme = 'dark' | 'light';
/** Выбор пользователя; system = следовать prefers-color-scheme (Q7, README). */
export type ThemePref = Theme | 'system';

/** Ключ общий с лендингом (`sb-theme`): хранятся только dark | light, отсутствие = системная. */
export function readThemePref(): ThemePref {
  const stored = local.get(storageKeys.theme);
  return stored === 'dark' || stored === 'light' ? stored : 'system';
}

export function writeThemePref(pref: ThemePref): void {
  if (pref === 'system') local.remove(storageKeys.theme);
  else local.set(storageKeys.theme, pref);
}

export function resolveTheme(pref: ThemePref, systemPrefersLight: boolean): Theme {
  if (pref === 'system') return systemPrefersLight ? 'light' : 'dark';
  return pref;
}

export function applyThemeAttribute(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
}
